<template>
  <el-drawer
    :visible.sync='settingsVisible'
    :direction="isMobile ? 'btt' : 'rtl'"
    size="850px"
    :before-close='closeProfile'
    close-on-press-escape
    v-cloak
  >
    <span slot="title"><b>Settings</b></span>
    <el-tabs class="settings-tabs" :tab-position='isMobile ? "top" : "left"' v-model="activeTab">
      <el-tab-pane name="profile">
        <span slot="label"><i class="el-icon-user"></i> Profile</span>
        <h2>Profile</h2>
        <form id="profile" class="profile-form" @submit.prevent='updateProfile'>
          <div class="profile-form--content">
            <label>profile pic</label>
            <div v-if="photoURL" class="profile-pic">
              <img :src="photoURL" alt="profile pic">
            </div>
            <input ref="uploadProfilePhotoInput" accept="image/jpeg, image/png" type="file" @change='(event) => chooseFile(event)'>
            <label>email
              <span v-if='emailVerified' class="description verified">Verified</span>
              <el-link v-else @click="sendVerificationEmail" type="warning" class="description">Click here to verify</el-link>
            </label>
            <input ref="email" type="email" v-model='email' placeholder="Email">
            <label>username <span class="description">{{ username + ':' + userUID }}</span></label>
            <input ref="username" type="text" v-model='username' placeholder="Username">
            <hr/>
            <h3>Update Password</h3>
            <label>new password</label>
            <input type="password" id="passwordNew" v-model='passwordNew' placeholder="New password" @input="judgePass" />
            <div v-if="judgePassword === false" class="pass-check">
              <div v-if="!lengthCheck">Password must be at least 8 characters.</div>
              <div v-if="!numberCheck">Password must contain at least one number.</div>
              <div v-if="!capitalCheck">Password must contain at least one capital letter.</div>
              <div v-if="!specialCheck">Password must contain at least one special character.</div>
            </div>
            <label>confirm password</label>
            <input :disabled='judgePassword' type="password" v-model='passwordConfirm' placeholder="Confirm password" @input="(passwordConfirm !== passwordNew && passwordConfirm !== '') ? matchCheck = false : matchCheck = true" />
            <div v-if="matchCheck === false" class="pass-check">
              <div>Confirm Password does not match New Password.</div>
            </div>
          </div>
        </form>
      </el-tab-pane>
      <el-tab-pane name="notifications">
        <span slot="label"><i class="el-icon-bell"></i> Notifications &amp; Alerts</span>
        <h2>Notifications &amp; Alerts</h2>
      </el-tab-pane>
      <el-tab-pane v-if="isTrainer" name="trainer">
        <span slot="label"><i class="el-icon-coin"></i> Trainer Information</span>
        <h2>Trainer Information</h2>
      </el-tab-pane>
      <el-tab-pane name="payment">
        <span slot="label"><i class="el-icon-bank-card"></i> Payment {{ isTrainer && '&amp; Payout' }}</span>
        <h2>Payment {{ isTrainer && '&amp; Payout' }}</h2>
        <div class="payment">
          <label>payment</label>
          <div class="payment-content">
            <StripeElements
              :stripe-key="stripeKey"
              :instance-options="instanceOptions"
              :elements-options="elementsOptions"
              #default="{ elements }"
              ref="elms"
            >
              <StripeElement
                type="card"
                :elements="elements"
                :options="cardOptions"
                ref="card"
              />
            </StripeElements>
            <br>
            <!-- Move pay() into Update function -->
            <el-button @click="pay">Update Card</el-button>
          </div>
        </div>
        <div class="payout" v-if="isTrainer">
          <label>payout</label>
        </div>
      </el-tab-pane>
      <el-tab-pane name="security">
        <span slot="label"><i class="el-icon-lock"></i> Security &amp; Privacy </span>
        <h2>Security &amp; Privacy</h2>
      </el-tab-pane>
      <el-tab-pane name="support">
        <span slot="label"><i class="el-icon-headset"></i> Support</span>
        <h2>Support</h2>
      </el-tab-pane>
    </el-tabs>
    <div class="settings--actions">
      <el-button :form="activeTab" round type="primary" native-type="submit">Update</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'
import firebase from 'firebase'

export default {
  props: {
    settingsVisible: Boolean
  },
  components: {
    StripeElements,
    StripeElement
  },
  data () {
    return {
      photoFile: {},
      photoURL: '',
      userUID: JSON.parse(localStorage.getItem('user')).uid,
      username: firebase.auth().currentUser.displayName,
      email: '',
      passwordNew: '',
      passwordConfirm: '',
      activeTab: 'profile',
      currentForm: 'profile',
      isTrainer: '',
      lengthCheck: true,
      numberCheck: true,
      capitalCheck: true,
      specialCheck: true,
      judgePassword: true,
      matchCheck: true,
      emailVerified: '',
      isMobile: '',
      stripeKey: 'pk_test_TYooMQauvdEDq54NiTphI7jx', // test key, don't hardcode
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        value: {
          postalCode: ''
        }
        // https://stripe.com/docs/stripe.js#element-options
      }
    }
  },
  methods: {
    pay () {
      // ref in template
      const groupComponent = this.$refs.elms
      const cardComponent = this.$refs.card
      // Get stripe element
      const cardElement = cardComponent.stripeElement

      // Access instance methods, e.g. createToken()
      groupComponent.instance.createToken(cardElement).then(result => {
        // Handle result.error or result.token
        console.log(result)
      })
    },
    sendVerificationEmail() {
      if (firebase.auth().currentUser.emailVerified === false) {
        firebase.auth().currentUser.sendEmailVerification({
          url: "https://app.workoutap.com",
        }).then(() => {
          this.$message({
            message: 'Verification email sent to ' + this.email,
            type: 'success'
          })
        })
      }
    },
    updateProfile() {
      let user = JSON.parse(localStorage.getItem('user')).uid

      // Profile updates
      if (this.activeTab == 'profile') {
        /****************
        * Update Profile Pic/Profile Image/Profile Photo  
        */
        if (this.$refs.uploadProfilePhotoInput.value != '') {
          firebase
            .storage()
            .ref('users/' + user + '/profile.jpg')
            .put(this.photoFile)
            .then(async () => {
              await firebase.storage().ref('users/' + user + '/profile.jpg').getDownloadURL().then(imgURL => {
                firebase
                  .auth()
                  .currentUser
                  .updateProfile({photoURL: imgURL})
                  .then(async () => {
                    localStorage.photoURL = await imgURL
                    this.photoURL = await imgURL
                    this.$refs.uploadProfilePhotoInput.value = ''
                    this.$message({
                      message: 'Profile Picture updated',
                      type: 'success'
                    })

                    firebase.database().ref('/scheduledWO/').once('value', snapshot => {
                      snapshot.forEach(child => {
                        if (child.val().uid == user) {
                          child.ref.update({
                            image: imgURL
                          })
                        }
                      })
                    })
                  }).catch(err => console.log(err.message))
              }).catch(err => console.log(err.message))
            }).catch(err => console.log(err.message))
        }

        /****************
        * Update Profile Email
        */
        if (this.email != JSON.parse(localStorage.getItem('user')).email) {
          firebase.auth().currentUser.updateEmail(this.email).then(async () => {
            let user = await JSON.parse(localStorage.getItem('user'))
            user.email = this.email
            localStorage.user = JSON.stringify(user)
            this.$message({
              message: 'Email updated to ' +  this.email,
              type: 'success'
            })
          }).catch(err => console.log(err.message))
        }

        /****************
        * Update Profile Username
        */
        if (this.username != JSON.parse(localStorage.getItem('user')).displayName) {
          firebase.auth().currentUser.updateProfile({displayName: this.username}).then(async () => {
            let user = await JSON.parse(localStorage.getItem('user'))
            localStorage.username = this.username
            user.displayName = this.username
            localStorage.user = JSON.stringify(user)
            this.$message({
              message: 'Username updated to ' +  this.username,
              type: 'success'
            })
          })
          firebase.database().ref('/scheduledWO/').once('value', snapshot => {
            snapshot.forEach(child => {
              if (child.val().uid == user) {
                child.ref.update({
                  host: this.username
                })
              }
            })
          })
        } else {
          console.log('no username update')
        }

        /****************
        * Update Profile Password
        */
        if (this.passwordNew === this.passwordConfirm && this.passwordNew != '') {
          firebase.auth().currentUser.updatePassword(this.passwordNew).then(() => {
            this.passwordNew = ''
            this.passwordConfirm = ''
            this.$message({
              message: 'Password updated',
              type: 'success'
            })
          }).catch(err => err.message)
        } else if ((this.passwordNew != '' || this.passwordConfirm != '') && this.passwordNew !== this.passwordConfirm) {
          this.$message({
            message: 'Password fields do not match',
            type: 'warning'
          })
        }
      }
    },
    judgePass() {
      if (!(this.passwordNew.length > 7) ||
      !/\d/.test(this.passwordNew) ||
      this.passwordNew == this.passwordNew.toLowerCase() ||
      !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.passwordNew)) {
        this.judgePassword = false
      }
      
      if (this.passwordNew == '') {
        this.judgePassword = true
      }

      // Length check
      this.passwordNew !== '' && !(this.passwordNew.length > 7) ?
        this.lengthCheck = false :
        this.lengthCheck = true
      // Number check
      this.passwordNew !== '' && !/\d/.test(this.passwordNew) ?
        this.numberCheck = false :
        this.numberCheck = true
      // Capital Letter check
      this.passwordNew !== '' && this.passwordNew == this.passwordNew.toLowerCase() ?
        this.capitalCheck = false :
        this.capitalCheck = true
      // Special Character check
      this.passwordNew !== '' && !/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(this.passwordNew) ?
        this.specialCheck = false :
        this.specialCheck = true
    },
    chooseFile (e) {
      this.photoFile = e.target.files[0]
    },
    closeProfile (done) {
      this.$emit('hideSettings')
      this.username = firebase.auth().currentUser.displayName
      done()
    }
  },
  created() {
    let uid = JSON.parse(localStorage.getItem('user')).uid
    firebase.database().ref().child(uid).child('isTrainer').get().then(snapshot => this.isTrainer = snapshot.val())
    this.emailVerified = firebase.auth().currentUser.emailVerified

    // ****** isMobile
    // Define our viewportWidth variable
    let viewportWidth
    // Set/update the viewportWidth value
    let setViewportWidth = () => {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth
    }
    // Log the viewport width into the console
    let logWidth = () => {
      if (viewportWidth > 991) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
    // Set our initial width and log it
    setViewportWidth()
    logWidth()
    // On resize events, recalculate and log
    window.addEventListener('resize', () => {
      setViewportWidth()
      logWidth()
    }, false)
  },
  mounted() {
    if (localStorage.user) {
      this.email = JSON.parse(localStorage.getItem('user')).email
      this.photoURL = JSON.parse(localStorage.getItem('user')).photoURL
      this.username = localStorage.username
    }
  }
}
</script>

<style>
.settings-tabs {
  display: flex;
  height: 100%; 
}

.settings-tabs .el-tabs__item {
  padding-left: 0;
}

.settings-tabs.el-tabs--left .el-tabs__header.is-left {
  float: none;
  margin-right: 16px;
}

.settings-tabs.el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}

.settings-tabs .el-tabs__content {
  width: 100%;
  overflow: auto;
}

.profile-form {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.profile-form .profile-form--content {
  overflow: auto;
  padding: 16px 0 0;
}

.profile-form .profile-form--content .profile-pic {
  min-width: 150px;
  width: 150px;
}

.profile-form .profile-form--content .profile-pic img {
  border-radius: 5px;
  width: 100%;
}

.profile-form .profile-form--content .upload-profile-pic {
  margin-bottom: 16px;
}

.settings--actions {
  border-top: 1px solid #ebebeb;
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 16px;
}

.pass-check {
  color: red;
  font-size: 12px;
}

.pass-check div:last-child {
  margin-bottom: 16px;
}

.description.el-link {
  font-size: 12px;
  font-weight: 600;
}

.description.verified {
  color: #67C23A;
}

.payment .payment-content  {
  margin: 16px 0;
}

.el-tabs__nav-scroll {
  overflow: auto;
}

@media (max-width: 991px) {
  .settings-tabs {
    height: calc(100% - 72px);
    flex-direction: column;
  }
}
</style>